// **********************************************************
// Search bar
// **********************************************************

const searchInput = document.querySelector('.search-bar__input-field');

if (searchInput) {
  searchInput.addEventListener('focus', (ev) => {
    const parentElement = ev.target.closest('.search-bar');
    parentElement.classList.add('is-focused');
  });

  searchInput.addEventListener('blur', (ev) => {
    const parentElement = ev.target.closest('.search-bar');
    if (!ev.target.value) {
      parentElement.classList.remove('is-focused');
    }
  });
}
